import { render, staticRenderFns } from "./DataTransfersResourceList.vue?vue&type=template&id=15b04e80"
import script from "./DataTransfersResourceList.vue?vue&type=script&lang=js"
export * from "./DataTransfersResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports